export enum AWSLoginStatus {
  NOT_LOGGED_IN = 'Not Logged In',
  LOGGING_IN_WITH_MFA = 'Logging in with MFA',
  LOGGED_IN_WITH_MFA = 'Logged in with MFA',
  LOGIN_WITH_MFA_FAILED = 'Login with MFA Failed',
  ROTATING_PULSE_ACCOUNT_CREDENTIALS = 'Rotating Pulse Account Profile Credentials',
  ROTATED_PULSE_ACCOUNT_CREDENTIALS = 'Rotated Pulse Account Profile Credentials',
  ROTATING_PULSE_ACCOUNT_CREDENTIALS_FAILED = 'Rotating Pulse Account Profile Credentials Failed',
}
